import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Approval } from 'src/app/approval/approval.model';
import { ApprovalService } from '../approval.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';

@Component({
  selector: 'fnsr-approval-list',
  standalone: true,
  imports: [AsyncPipe, IconComponent, DatePipe, LoadComponent],
  templateUrl: './approval-list.component.html',
  styleUrls: ['./approval-list.component.scss']
})
export class ApprovalListComponent {
  approvals$: Observable<Approval[]>

  constructor(
    private approvalService: ApprovalService,
    public router: Router
  ) {
    this.approvals$ = this.approvalService.getApprovals();
  }

  deleteApproval(approval: Approval): void {
    if (confirm('Möchtest Du diese Freigabe wirklich löschen?')) {
      this.approvalService.deleteApproval(approval._id).subscribe(
        result => {
          console.log(result);
          this.approvals$ = this.approvalService.getApprovals();
        },
        (err: Error) => {
          console.log(err);
        }
      );
    }
  }
}